"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsEnum = void 0;
var PermissionsEnum;
(function (PermissionsEnum) {
    PermissionsEnum["ORGANIZATION_ACCOUNT_DELETE"] = "organization_accounts:delete";
    PermissionsEnum["ORGANIZATION_ACCOUNT_UPDATE"] = "organization_accounts:update";
    PermissionsEnum["PROCURE_VENDOR_CONTACT_CREATE"] = "procure_vendor_contacts:create";
    PermissionsEnum["PROCURE_VENDOR_CONTACT_DELETE"] = "procure_vendor_contacts:delete";
    PermissionsEnum["PROCURE_VENDOR_CONTACT_UPDATE"] = "procure_vendor_contacts:update";
    PermissionsEnum["PROCURE_VENDOR_CREATE"] = "procure_vendors:create";
    PermissionsEnum["PROCURE_VENDOR_DELETE"] = "procure_vendors:delete";
    PermissionsEnum["PROCURE_VENDOR_UPDATE"] = "procure_vendors:update";
    PermissionsEnum["PROPERTIES_CREATE"] = "properties:create";
    PermissionsEnum["PROPERTIES_DELETE"] = "properties:delete";
    PermissionsEnum["PROPERTIES_UPDATE"] = "properties:update";
    PermissionsEnum["PROPERTY_USERS_DELETE"] = "property_users:delete";
    PermissionsEnum["PROPERTY_USERS_UPDATE"] = "property_users:update";
    PermissionsEnum["USERS_CREATE"] = "users:create";
    PermissionsEnum["USERS_DELETE"] = "users:delete";
    PermissionsEnum["USER_ROLE_UPDATE"] = "user_roles:update";
    PermissionsEnum["WORK_ORDERS_CREATE"] = "work_orders:create";
    PermissionsEnum["WORK_ORDERS_DELETE"] = "work_orders:delete";
    PermissionsEnum["WORK_ORDER_APPROVAL_UPDATE"] = "work_order_approval:update";
    PermissionsEnum["WORK_ORDER_ASSIGNEE_UPDATE"] = "work_order_assignee:update";
    PermissionsEnum["WORK_ORDER_ATTACHMENTS_CREATE"] = "work_order_attachments:create";
    PermissionsEnum["WORK_ORDER_ATTACHMENTS_DELETE"] = "work_order_attachments:delete";
    PermissionsEnum["WORK_ORDER_ATTACHMENTS_UPDATE"] = "work_order_attachments:update";
    PermissionsEnum["WORK_ORDER_COMMENTS_CREATE"] = "work_order_comments:create";
    PermissionsEnum["WORK_ORDER_DETAILS_UPDATE"] = "work_order_details:update";
    PermissionsEnum["WORK_ORDER_PRIORITY_UPDATE"] = "work_order_priority:update";
    PermissionsEnum["WORK_ORDER_STATUS_UPDATE"] = "work_order_status:update";
    PermissionsEnum["WORK_ORDER_BID_UPDATE"] = "work_order_bid:update";
})(PermissionsEnum || (exports.PermissionsEnum = PermissionsEnum = {}));
//# sourceMappingURL=user-permissions.types.js.map